import { TPO_PLANNER_TAB } from '../config/testIds';
import CalendarView from './CalendarPage/CalendarView';
import EventsView from './EventsPage/EventsView';
import MetricView from './MetricPage/MetricView';
import PlanViewHeader from './PlanViewHeader';
import { usePlanDetailsContext } from './context/PlanDetailsContext';

const PlannerTab = ({ planDetails }: { planDetails: { planId: string; planName: string } }) => {
    const { planId, planName } = planDetails;
    const { activeView } = usePlanDetailsContext();

    // Keep CalendarView mounted (merely hidden) while on Metric View instead of
    // unmounting it. currentPlanDetails (customer/category/year header) is only
    // ever populated from the calendar data query, so tearing that query down
    // whenever Metric View is active would leave the header stale.
    const showCalendar = activeView === 'calendar' || activeView === 'metric-view';

    return (
        <div data-testid={TPO_PLANNER_TAB} data-state-active-view={activeView}>
            {activeView !== 'event' ? <PlanViewHeader planId={planId} planName={planName ?? ''} /> : null}
            {showCalendar ? (
                <div className={activeView === 'calendar' ? undefined : 'hidden'}>
                    <CalendarView planId={planId} planName={planName ?? ''} />
                </div>
            ) : null}
            {activeView === 'metric-view' ? <MetricView planId={planId} planName={planName ?? ''} /> : null}
            {activeView === 'event' ? <EventsView planId={planId} /> : null}
        </div>
    );
};

export default PlannerTab;
